import { ModalActions } from '@ui-kit/components/Modal/Modal';
import { useTranslation } from 'react-i18next';
import { LinkButton } from '@/components/buttons';
import type { ModalProps } from '@/components/ModalRenderer/components/types';
import { Modal } from '@/components/ModalRenderer/Modal';
import { QueryParams } from '@/constants/QueryParam';
import { routeMap } from '@/routes/routeMap';
import { DataList, DataListItem, DataListLabel, DataListValue } from '@/ui-kit/components/DataList';
import { formatDate } from '@/utils/date';
import { constructURL } from '@/utils/url';

type Payload = { loanIdProtectDebt: number; idProtectValidThrough: string };
type Props = ModalProps<Payload>;

function RemainingDebtInfoLoanIdProtect({ payload: { loanIdProtectDebt, idProtectValidThrough } }: Props) {
  const { t } = useTranslation(['Modal', 'Common']);

  return (
    <Modal title={t('RemainingDebtInfoLoanIdProtect.title')}>
      <div className="flex flex-col gap-4">
        <p>{t('RemainingDebtInfoLoanIdProtect.info1')}</p>
        <p>{t('RemainingDebtInfoLoanIdProtect.info2')}</p>
        <p>
          {t('RemainingDebtInfoLoanIdProtect.info3', {
            dateValidThrough: formatDate(new Date(idProtectValidThrough)),
          })}
        </p>

        <DataList>
          <DataListItem>
            <DataListLabel>{t('RemainingDebtInfoLoanIdProtect.loanIdProtectProduct')}</DataListLabel>
            <DataListValue>{t('Common:money', { amount: loanIdProtectDebt })}</DataListValue>
          </DataListItem>
        </DataList>
      </div>
      <ModalActions>
        <LinkButton
          to={constructURL(routeMap.loan.deposit, {
            relative: true,
            queryParams: {
              [QueryParams.SELECT_MAX_AMOUNT]: 'true',
            },
          })}
        >
          {t('RemainingDebtInfoLoanIdProtect.button')}
        </LinkButton>
      </ModalActions>
    </Modal>
  );
}

export default RemainingDebtInfoLoanIdProtect;
